import { ColorX } from "IZOX/STATIC";

/**
 * 
 * @type {Object.<string, import("../QTable").stylesparams>}
 */
let dark = {
  table: {
    bW: 1,
    bColor: ColorX.CSS("greyOut"),
  },
  headerContainer: {
    style: {
      borderBottomWidth: 1,
      borderBottomStyle: "solid",
      borderBottomColor: ColorX.CSS("lightGrey")
    }
  },
  headerCell: {
    
  },
  headerCellText: {
    fontSize: 14,
    bold: true,
    colorTransition: true,
    color: ColorX.CSS("dmWhite")
  },
  cardHeaderText: {

  },
  cardCell: {
    bold: true,
    fontSize: 14
  },
  headerRow: {
    
  },
  body: {

  },
  row: {

  },
  evenRow: {
    bgColor: ColorX.CSS("bgDark")
  },
  hoverRow: {
    bgColor: ColorX.CSS("pureDark")
  },
  cell: {

  },
  cellText: {
    fontSize: 14,
    ellipsisMode: "ellipsis",
    color: ColorX.CSS("dmWhite")
  },
  footerContainer: {

  },
  footer: {
    p: 5,
    style: {
      borderTopWidth: 1,
      borderTopStyle: "solid",
      borderTopColor: ColorX.CSS("lightGrey")
    }
  },
  selectedRow: {
    bgColor: ColorX.CSS("cmBlue", 0.3)
  },
  hoverSelectedRow: {
    bgColor: ColorX.CSS("cmBlue", 0.5)
  },
  filterIconShow: {
    color: ColorX.CSS("pureOrange")
  },
  filterIconHide: {
    color: ColorX.CSS("cmBlue")
  },
  setColumnIcon: {
    color: ColorX.CSS("dmBtnBlue")
  },
  closeIcon: {
    color: ColorX.CSS("pureRed")
  },
  filterInput: {
    bgColor: ColorX.CSS("dmBgDark"),
    color: ColorX.CSS("dmWhite")
  },
  filterDropDown: {
    bgColor: ColorX.CSS("dmBgDark"),
    color: ColorX.CSS("dmWhite")
  },
  selectBox: {
    bgColor: ColorX.CSS("dmBgDark"),
    bColor: ColorX.CSS("dmWhite"),
    color: ColorX.CSS("dmBgDark"),
  },
  inSSFApply: {
    bColor: ColorX.CSS("green"),
    bgColor: ColorX.CSS("green"),
    colorTransition: true
  },
  notSSFApply: {
    bColor: ColorX.CSS("green"),
    bgColor: ColorX.CSS("transparent"),
    colorTransition: true
  },
  inSSFApplyText: {
    color: ColorX.CSS("pureWhite"),
    colorTransition: true
  },
  notSSFApplyText: {
    color: ColorX.CSS("pureGreen"),
    colorTransition: true
  },
  inSSFReset: {
    bColor: ColorX.CSS("greyOut"),
    colorTransition: true
  },
  notSSFReset: {
    bColor: ColorX.CSS("greyOut"),
    colorTransition: true
  },
  inSSFResetText: {
    color: ColorX.CSS("greyOut"),
    colorTransition: true
  },
  notSSFResetText: {
    color: ColorX.CSS("greyOut"),
    colorTransition: true
  }
};

export default dark;